import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
//import "../styles.css";
import "./uploader.css";
import DataTable from "./DataTable";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as XLSX from "xlsx"; // Import the XLSX library

function CsvUploader() {
  const {
    REACT_APP_DB,
    REACT_APP_PORT_FRONT,
    REACT_APP_PORT_BACK,
    REACT_APP_PORT_HTTP,
    REACT_APP_FROM,
  } = process.env;
  const location = useLocation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  //console.log(REACT_APP_PORT_HTTP, REACT_APP_DB, REACT_APP_PORT_BACK);
  // State declarations
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedType, setSelectedType] = useState("CSV");
  // const [loading, setLoading] = useState(false);
  const [invoiceid, setInvoiceid] = useState("");
  const [datausername, setDatausername] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showdateinvoiceSearch, setShowdateinvoiceSearch] = useState(false);
  const [dateString, setDateString] = useState("");

  // เพิ่ม state ต่อไปนี้ที่ส่วนบนของคอมโพเนนต์
  const [useDateRange, setUseDateRange] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  //const username = location.state?.username;

  const username = location.state?.idvender || "User";
  const namecompany = location.state?.fullname || "company";
  const [searchMode, setSearchMode] = useState("compare");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  console.log("namecompany", namecompany);
  useEffect(() => {
    if (username) {
      setDatausername(username);
    }
  }, [location.state?.username]);

  // Export data as Excel
  const exportToExcel = () => {
    // Get the formatted date (e.g., YYYY-MM-DD) from the selectedDate state
    const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

    // Set the file name based on the invoice date
    const fileName = `Invoice_${formattedDate}.xlsx`;

    const ws = XLSX.utils.json_to_sheet(tableData); // Convert table data to worksheet
    const wb = XLSX.utils.book_new(); // Create a new workbook
    XLSX.utils.book_append_sheet(wb, ws, "Data"); // Append the sheet to the workbook

    // Generate Excel file and trigger download with the dynamic file name
    XLSX.writeFile(wb, fileName);
  };

  // Handler functions
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleInputinvoice = (e) => setInvoiceid(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedType === "CSV" && file) {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/upload-csv`
          : `/api/upload-csv`;

      await uploadFile(url, "CSV");
    } else {
      setMessage("Please select a CSV file to upload");
    }
    clearFileInput(); // 🔸 เคลียร์ช่องเลือกไฟล์หลังอัปโหลด
  };

  const handleUpload = async (e) => {
    console.log("frontend begin click upload file excel");
    e.preventDefault();
    if (selectedType === "EXCEL" && file) {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/upload_excel`
          : `/api/upload_excel`;

      await uploadFile(url, "EXCEL");
    } else {
      setMessage("Please select an EXCEL file to upload");
    }
    clearFileInput(); // 🔸 เคลียร์ช่องเลือกไฟล์หลังอัปโหลด
  };

  const uploadFile = async (url, type) => {
    console.log("beginuploadFile");
    setTableData([]);
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);
    try {
      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        params: { username },
      });
      setTableData(response.data.data);
      setMessage("");
    } catch (error) {
      console.error("error_Afterupload_", error);
      setTableData([]);
      setMessage(`Failed to upload ${type}`);
    } finally {
      console.log("end-uploadFile");
      setLoading(false);
    }
  };

  const handlechkinvoice = async () => {
    setTableData([]);
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/loadfrminvoiceid`
          : `/api/loadfrminvoiceid`;

      const response = await axios.post(
        // // `${REACT_APP_PORT_HTTP}://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/loadfrminvoiceid`,
        // `/poprice/api/loadfrminvoiceid`,
        url,
        {
          parainvoicdid: invoiceid,
          parausersupplier: datausername,
        },
      );

      if (response.data?.length > 0) {
        setTableData(response.data);
        setMessage("");
      } else {
        alert(`No invoice found with ID: ${invoiceid}`);
        setInvoiceid("");
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      setMessage("An error occurred while searching for the invoice.");
    }
  };
  const handledeletedateinvoice = () => {
    if (!selectedDate) {
      alert("Please select a date");
      return;
    }

    const deleteParams = {
      username: datausername,
      date: selectedDate,
    };

    // 🔐 แสดงกล่องยืนยันก่อนลบ
    const confirmDelete = window.confirm(
      `Are you sure you want to delete data for ${selectedDate}?`,
    );

    if (!confirmDelete) {
      return; // ผู้ใช้กดยกเลิก
    }

    console.log("Deleting with params:", deleteParams);
    const url =
      REACT_APP_FROM === "local"
        ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/deletebydateinvoice`
        : `/api/deletebydateinvoice`;
    axios
      .post(url, deleteParams)
      .then((response) => {
        setTableData([]);
        alert("Data deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting date data:", error);
        alert("Error deleting data");
      });
  };
  const handlechkdateinvoice = () => {
    let dateParams = {};

    console.log("vendermatco_");
    console.log("searchMode_", searchMode);

    // กำหนดค่าที่จะใช้ส่งไป API
    const parausersupplier =
      namecompany === "matco" ? selectedvenderid.split("|")[0] : datausername;

    console.log("vender_", datausername);
    console.log("parausersupplier_", parausersupplier);

    // ตรวจสอบ Date Range
    if (useDateRange) {
      if (!startDate || !endDate) {
        alert("Please select both start and end dates");
        return;
      }

      if (new Date(endDate) < new Date(startDate)) {
        alert("End date cannot be earlier than start date");
        return;
      }

      dateParams = {
        startDate,
        endDate,
        parausersupplier,
        paradateinvoicd: startDate,
        paradateendinvoicd: endDate,

        // Search Mode
        searchMode: searchMode,
      };
    } else {
      // ตรวจสอบ Single Date
      if (!selectedDate) {
        alert("Please select a date");
        return;
      }

      dateParams = {
        selectedDate,
        parausersupplier,
        paradateinvoicd: selectedDate,

        // Search Mode
        searchMode: searchMode,
      };
    }

    console.log("dateselect_", dateParams);

    const url =
      REACT_APP_FROM === "local"
        ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/loadfrmdateinvoice`
        : `/api/loadfrmdateinvoice`;

    // =========================
    // เริ่ม Loading
    // =========================
    setLoading(true);

    axios
      .post(url, dateParams)
      .then((response) => {
        setTableData(response.data);

        console.log("Date data loaded successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error loading date data:", error);

        setMessage("Error loading date data");
      })
      .finally(() => {
        // API ทำงานเสร็จแล้ว
        setLoading(false);
      });
  };

  const handlechkdateinvoice_oldOK = () => {
    let dateParams = {};

    console.log("vendermatco_");
    console.log("searchMode_", searchMode);

    // กำหนดค่าที่จะใช้ส่งไป API
    const parausersupplier =
      namecompany === "matco" ? selectedvenderid.split("|")[0] : datausername;

    console.log("vender_", datausername);
    console.log("parausersupplier_", parausersupplier);

    // ตรวจสอบ Date Range
    if (useDateRange) {
      if (!startDate || !endDate) {
        alert("Please select both start and end dates");
        return;
      }

      if (new Date(endDate) < new Date(startDate)) {
        alert("End date cannot be earlier than start date");
        return;
      }

      dateParams = {
        startDate,
        endDate,
        parausersupplier,
        paradateinvoicd: startDate,
        paradateendinvoicd: endDate,

        // เพิ่ม Search Mode
        searchMode: searchMode,
      };
    } else {
      // ตรวจสอบ Single Date
      if (!selectedDate) {
        alert("Please select a date");
        return;
      }

      dateParams = {
        selectedDate,
        parausersupplier,
        paradateinvoicd: selectedDate,

        // เพิ่ม Search Mode
        searchMode: searchMode,
      };
    }

    console.log("dateselect_", dateParams);

    const url =
      REACT_APP_FROM === "local"
        ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/loadfrmdateinvoice`
        : `/api/loadfrmdateinvoice`;

    axios
      .post(url, dateParams)
      .then((response) => {
        setTableData(response.data);

        console.log("Date data loaded successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error loading date data:", error);
      });
  };

  const fileInputRef = useRef(null); // 🔸 สร้าง ref

  const clearFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // เคลียร์ input
    }
  };

  const [venderId, setVenderId] = useState("");

  const [dataListVenderid, setListVenderid] = useState([]);
  const [selectedvenderid, setSelectedvenderid] = useState("");

  // ดึงข้อมูล venderid จาก API
  useEffect(() => {
    const fetchvenderid = async () => {
      try {
        const url =
          REACT_APP_FROM === "local"
            ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/showidvender`
            : `/api/showidvender`;
        const response = await fetch(url);
        const data = await response.json();
        console.log(data + "_test");
        setListVenderid(data);
      } catch (error) {
        console.error("Error fetching buyers:", error);
      }
    };
    fetchvenderid();
  }, []);

  return (
    <div className="csv-uploader-container">
      {/* Navigation Bar */}
      <nav className="navbar">
        <div className="find-buttons">
          <button
            className={`search-toggle-btn ${showSearch ? "active" : ""}`}
            onClick={() => {
              setShowSearch(!showSearch);
              setShowdateinvoiceSearch(false);
            }}
          >
            Find InvoiceID
          </button>
          <button
            className={`search-toggle-btn ${
              showdateinvoiceSearch ? "active" : ""
            }`}
            onClick={() => {
              setShowdateinvoiceSearch(!showdateinvoiceSearch);
              setShowSearch(false);
            }}
          >
            Find Date Invoice
          </button>
        </div>
        <div className="user-section">
          <span className="welcome-text">Welcome Supplier : {namecompany}</span>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </nav>

      {/* Search Forms */}
      <div className="search-forms-container">
        {showSearch && (
          <div className="search-form">
            <label className="form-label">Please input Invoice ID</label>
            <div className="input-group">
              <input
                type="text"
                //className="form-input large-input"
                autoFocus
                placeholder="Invoice ID"
                value={invoiceid}
                onChange={handleInputinvoice}
                onKeyDown={(e) => e.key === "Enter" && handlechkinvoice()}
              />
              <button
                type="button"
                className="action-button"
                onClick={handlechkinvoice}
              >
                Load
              </button>

              <button
                type="button"
                className="action-button"
                onClick={exportToExcel} // Add the Export button
              >
                Export Data
              </button>
            </div>
          </div>
        )}
        {showdateinvoiceSearch && (
          <div className="search-form">
            <label className="form-label">Please Select Date Invoice</label>

            {namecompany === "matco" && (
              <>
                <label htmlFor="buyer-select" style={{ marginRight: "10px" }}>
                  Select venderID:
                </label>

                <input
                  list="vender-name-list"
                  id="vender-name-input"
                  value={selectedvenderid}
                  onChange={(e) => setSelectedvenderid(e.target.value)}
                  onFocus={() => setSelectedvenderid("")}
                  placeholder="Type or select a venderid"
                />
                <datalist id="vender-name-list">
                  {dataListVenderid.map((item, index) => (
                    <option key={index} value={item.VenderID} />
                  ))}
                </datalist>
              </>
            )}

            {/* เงื่อนไขแสดง Checkbox "Search by Date Range" เฉพาะ matco */}
            {namecompany === "matco" && (
              <>
                {/* Search Mode */}

                {/* Date Range */}
                {/* Date Range */}
                <div className="date-range-option">
                  <label htmlFor="dateRangeCheckbox">
                    Search by Date Range
                  </label>

                  <input
                    type="checkbox"
                    id="dateRangeCheckbox"
                    checked={useDateRange}
                    onChange={(e) => setUseDateRange(e.target.checked)}
                  />
                </div>

                {useDateRange && namecompany === "matco" && (
                  <div className="search-mode">
                    <div className="search-mode-title">Search Mode:</div>

                    <div className="search-mode-options">
                      <label className="search-mode-item">
                        <input
                          type="radio"
                          id="compareMode"
                          name="searchMode"
                          value="compare"
                          checked={searchMode === "compare"}
                          onChange={(e) => setSearchMode(e.target.value)}
                        />
                        <span>Compare</span>
                      </label>

                      <label className="search-mode-item">
                        <input
                          type="radio"
                          id="supplierMode"
                          name="searchMode"
                          value="supplier"
                          checked={searchMode === "supplier"}
                          onChange={(e) => setSearchMode(e.target.value)}
                        />
                        <span>Supplier Only</span>
                      </label>
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="input-group">
              {/* ถ้าไม่ใช้ Date Range หรือไม่ใช่ matco: แสดงฟิลด์เลือกวันเดียว */}
              {(!useDateRange || namecompany !== "matco") && (
                <input
                  type="date"
                  // className="form-input large-input"

                  value={selectedDate || ""}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handlechkdateinvoice()}
                />
              )}

              {/* แสดงช่วงวันที่: เฉพาะ matco + เลือก checkbox */}
              {namecompany === "matco" && useDateRange && (
                <div
                  className="date-range-container"
                  style={{ display: "flex", gap: "10px" }}
                >
                  <div>
                    <label>From:</label>
                    <input
                      type="date"
                      className="form-input"
                      value={startDate || ""}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>To:</label>
                    <input
                      type="date"
                      className="form-input"
                      value={endDate || ""}
                      onChange={(e) => setEndDate(e.target.value)}
                      min={startDate}
                    />
                  </div>
                </div>
              )}

              {/* ปุ่มดำเนินการ */}
              <button
                type="button"
                className="action-button"
                onClick={handlechkdateinvoice}
                disabled={loading}
              >
                {loading
                  ? "Loading..."
                  : `Load ${
                      useDateRange && namecompany === "matco"
                        ? "Date Range"
                        : "For Date"
                    }`}
              </button>

              {namecompany !== "matco" && (
                <button
                  type="button"
                  className="action-button"
                  onClick={handledeletedateinvoice}
                >
                  Delete For Date
                </button>
              )}

              <button
                type="button"
                className="uaction-button"
                onClick={exportToExcel}
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Main Upload Section */}
      {!showSearch && !showdateinvoiceSearch && (
        <div className="upload-section">
          <h2 className="section-title">Select import data type</h2>
          <div className="radio-group">
            <label className="">
              <input
                type="radio"
                value="CSV"
                checked={selectedType === "CSV"}
                onChange={(e) => setSelectedType(e.target.value)}
              />
              <span>CSV</span>
            </label>
            <label className="">
              <input
                type="radio"
                value="EXCEL"
                checked={selectedType === "EXCEL"}
                onChange={(e) => setSelectedType(e.target.value)}
              />
              <span>Excel</span>
            </label>
          </div>

          <form onSubmit={selectedType === "CSV" ? handleSubmit : handleUpload}>
            <div className="file-upload-group">
              <label className="file-upload-label">
                <span>Choose {selectedType} file</span>
                <input
                  type="file"
                  ref={fileInputRef} // 🔸 เพิ่ม ref ตรงนี้
                  accept={selectedType === "CSV" ? ".csv" : ".xlsx, .xls"}
                  onChange={handleFileChange}
                  className="file-input"
                />
              </label>
              <button type="submit" className="upload-button">
                Upload Data
              </button>
              <button
                type="button"
                className="upload-button"
                onClick={exportToExcel} // Add the Export button
              >
                Export Data
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Status Messages */}
      {loading && <div className="loading-indicator">Loading...</div>}
      {message && <div className="message">{message}</div>}

      {/* Data Table */}
      {tableData.length > 0 && (
        <div className="table-container">
          <DataTable tableData={tableData} />
        </div>
      )}
    </div>
  );
}

export default CsvUploader;
